export default __webpack_public_path__ + "static/media/logo_doopage.63a47070.png";